var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.9878 23.6909L6.06162 21.6359M1.08496 16.1032H4.5979M2.9878 8.51547L6.06162 10.4124M8.11083 2.98275L10.0137 6.30238M15.2831 0.927734V4.7216M22.3089 2.98275L20.5525 6.30238M27.432 8.51547L24.3582 10.4124M25.5291 16.1032H29.3348M24.0654 21.6359L27.432 23.6909",
    stroke: "#2B5CAA",
    strokeWidth: 1.31661,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8919 24.165H20.4061M10.8919 24.165L11.6238 26.378M10.8919 24.165C-5.35544 1.55987 35.9317 0.333056 20.4061 24.165M20.4061 24.165L19.8206 26.378M19.8206 26.378H11.6238M19.8206 26.378L19.3815 29.8558M11.6238 26.378L11.9165 29.8558M11.9165 29.8558H19.3815M11.9165 29.8558C13.3802 33.6497 18.5032 33.1754 19.3815 29.8558",
    stroke: "#2B5CAA",
    strokeWidth: 1.31661,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9657 24.1648V18.3554M17.0395 24.1648V18.3554M11.9165 17.6836L13.2339 18.9482L14.4048 17.9997L15.4294 18.9482L16.7468 17.9997L17.7714 18.9482L19.0887 17.9997",
    stroke: "#2B5CAA",
    strokeWidth: 1.31661,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.5e9b753a60cd41a5e95731111345500a.svg";
export { ForwardRef as ReactComponent };